import {
  startAuthentication,
  startRegistration,
  browserSupportsWebAuthn,
} from "@simplewebauthn/browser";

import apiClient from "./client.js";

export function passkeysSupported() {
  return browserSupportsWebAuthn();
}

// ---------------------------------------------------------------------------
// Sign-in (public)
// ---------------------------------------------------------------------------

/**
 * Begin a passkey sign-in ceremony. If `email` is provided the server can
 * scope the allowCredentials list; otherwise the browser does a usernameless
 * discoverable-credential lookup.
 *
 * Returns the full session payload (access_token, user, workspaces).
 */
export async function signInWithPasskey(email = null) {
  const optionsResp = await apiClient.post(
    "/auth/passkey/authenticate/options",
    email ? { email } : {}
  );
  const { options, challenge_ref } = optionsResp.data.data;

  const credential = await startAuthentication({ optionsJSON: options });

  const verifyResp = await apiClient.post("/auth/passkey/authenticate/verify", {
    challenge_ref,
    credential,
  });
  return verifyResp.data.data;
}

// ---------------------------------------------------------------------------
// Registration (authenticated)
// ---------------------------------------------------------------------------

export async function registerPasskey(name = null) {
  const optionsResp = await apiClient.post(
    "/auth/me/passkeys/register/options",
    {}
  );
  const { options, challenge_ref } = optionsResp.data.data;

  const credential = await startRegistration({ optionsJSON: options });

  const verifyResp = await apiClient.post("/auth/me/passkeys/register/verify", {
    challenge_ref,
    credential,
    name,
  });
  return verifyResp.data.data;
}

export async function listPasskeys() {
  const response = await apiClient.get("/auth/me/passkeys");
  return response.data.data;
}

export async function renamePasskey(id, name) {
  await apiClient.patch(`/auth/me/passkeys/${id}`, { name });
}

export async function deletePasskey(id) {
  await apiClient.delete(`/auth/me/passkeys/${id}`);
}
